// extracted by mini-css-extract-plugin
export default {"main":"ShowcaseMain_main__c5SlA"};